import streamBlob from 'blob-stream';
import csvStringify from 'csv-stringify/lib/es5';
import fp from 'lodash/fp';
import pdfDocument from 'pdfkit';

export const getCsvStream = (options) => csvStringify(options);
export const getPdfStream = (options) => new pdfDocument(options);
export const getBlobStream = () => streamBlob();

export const downloadBlobStreamFile = (blobStream, fileName) => {
  blobStream.on('finish', () => {
    const blob = blobStream.toBlob();
    const blobUrl = window.URL.createObjectURL(blob);

    // IE specific fixes.
    // @see https://stackoverflow.com/a/46233123
    if (navigator.msSaveOrOpenBlob) {
      navigator.msSaveOrOpenBlob(blob, fileName);
    }
    else {
      var a = document.createElement('a');
      document.body.appendChild(a);
      a.setAttribute('style', 'display: none');
      a.setAttribute('href', blobUrl);
      a.setAttribute('download', fileName);
      a.click();
      window.URL.revokeObjectURL(blobUrl);
      document.body.removeChild(a);
    }
  });

  return blobStream;
};

export const writeDataToCsvStream = (stream, data) => {
  for (var i = 0; i < data.length; i++) {
    stream.write(data[i]);
  }

  stream.end();

  return stream;
}

// Map of methods for pdfKit streams to
// allow dynamic references, otherwise a
// call to fp.get does nothing... weird
// Add missing methods here to be able
// to use them in a report
const pdfStreamMap = (stream) => ({
  addPage: (options) => stream.addPage(options),
  circle: (centreX, centreY, radius) => stream.circle(centreX, centreY, radius),
  dash: (length, hash) => stream.dash(length, hash),
  fill: (colour) => stream.fill(colour),
  fillAndStroke: (fillColour, strokeColour) => stream.fillAndStroke(fillColour, strokeColour),
  fillColour: (colour) => stream.fillColor(colour),
  font: (font) => stream.font(font),
  fontSize: (fontSize) => stream.fontSize(fontSize),
  lineWidth: (lineWidth) => stream.lineWidth(lineWidth),
  moveDown: (lines) => stream.moveDown(lines),
  moveUp: (lines) => stream.moveUp(lines),
  path: (path) => stream.path(path),
  rect: (x, y, width, height) => stream.rect(x, y, width, height),
  restore: () => stream.restore(),
  save: () => stream.save(),
  scale: (scale) => stream.scale(scale),
  stroke: (colour) => stream.stroke(colour),
  text: (text, xOrOptions, y, options) => stream.text(text, xOrOptions, y, options),
  image: (src, x, y, options) => stream.image(src, x, y, options),
  translate: (x, y) => stream.translate(x, y)
});

export const writeDataToPdfStream = (stream, data, showPageNumber = true) => {
  if (showPageNumber) {
    var pageNumber = 1;
    const page = stream.page;

    const drawPageNumber = () => {
      stream.font('Helvetica');
      stream.fontSize(10);
      stream.text(pageNumber++, page.width - 50, page.height - 20, {
        lineBreak: false,
      }).fillColor('black');
    };

    drawPageNumber();

    stream.on('pageAdded', () => {
      drawPageNumber();
    });
  } 

  for (var i = 0; i < data.length; i++) {
    const [key, value] = data[i];
    const method = fp.get(key)(pdfStreamMap(stream));

    if (value) {
      method && method(...value);
    } else {
      method && method();
    }
  }

  stream.end();

  return stream;
};



// WEBPACK FOOTER //
// ./src/utils/stream.js